
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>Mutmassliche Schändung vor einer Hochzeit</h4>
    <p>
  William W. gerät in eine Grenzkontrolle. Er hatte sich erneut ins Ausland abgesetzt, die GPS-Überwachung
  verunmöglicht. Das Amt verwarnt ihn. Doch der 45-Jährige zeigt wenig Reue. Stattdessen beklagt er sich über das neue
  Gutachten. Es sei «eine Frechheit anzunehmen, dass er pädophil sei», notiert die Bewährungshilfe am 26. Juli 2018.
    </p>
    <p>
  Zwei Tage darauf ist W. laut Anklageschrift in der Wohnung von Bekannten, die sich gerade auf eine Hochzeit
  vorbereiten. Als sie sich umgezogen hätten, sei der Beschuldigte mit den beiden Söhnen allein im Wohnzimmer gewesen.
  Zuerst habe er sich am jüngeren Buben, einem Vierjährigen, vergangen. Der zwei Jahre ältere Bruder wollte laut
  Staatsanwaltschaft davonlaufen, um die Mutter zu informieren. Doch William W. habe ihn am Bein gepackt und sich auch
  an ihm vergriffen. Obwohl sich der Primarschüler mit Fäusten gewehrt habe. W. bestreitet die sexuelle Handlungen mit
  Kindern, sexuelle Nötigung und Schändung, welche ihm die Staatsanwaltschaft über ein Jahr später vorwerfen wird.Doch
  vorerst passiert nichts.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;